import styled from 'styled-components';
import media from '../../styles/Media.styled';

export const PageLayoutContainer = styled.div`
    /* For Safari Browser */
    @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
        @media screen and (max-width: 576px) {
            & main {
                display: block;
                background: #140f4b;
                height: 100%;
            }
        }
    }

    ${media.mobileDevice`
        & main{
            display: block;
             background: ${props => props.isCondensedView ? 'none' : '#140f4b'};
        }
    `};
    main {
        margin-top: ${(props) =>
            props.bannerHeight ? props.bannerHeight : '3.75rem'};
        width: 100%;
        margin-bottom: ${(props) =>
            props.bannerHeight ? '40px' : ''};
        height: ${(props) =>
            props.bannerHeight ? 'calc(100vh - ' + props.bannerHeight + ' - 60px)' : 'auto'};
        
        /* Mobile devices landscape */
        @media only screen 
        and (max-width: 1000px) 
        and (max-height: 500px) 
        and (orientation: landscape) {
            height: auto;
        }
         ${media.mobileDevice`
            height: auto;
        `};
    }
`;

export const NavMainContainer = styled.div`
    display: flex;
    margin-top: ${(props) =>
        props.rquiredMargin ? props.rquiredMargin : 'unset'};
    background: ${(props) =>
        props.maintainanceBackground ? '#140f4b' : 'unset'};
    position: ${(props) => (props.applyFixedPosition ? 'fixed' : 'unset')};
    width: 100%;
    ${media.mobileDevice`
        display: block;
        position:unset;
        margin-top: ${(props) =>
            props.rquiredMarginMobile ? props.rquiredMarginMobile : '7rem'};
    `} 
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation: landscape) {
        // position:absolute;
        
}
`;
